import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Map = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.242 6.03L19.24 4.03C19.163 4.011 19.083 4 19 4C18.795 4 18.604 4.062 18.446 4.168L12.814 7.923L5.243 6.03C4.944 5.955 4.628 6.022 4.385 6.212C4.142 6.402 4 6.692 4 7V25C4 25.459 4.312 25.859 4.758 25.97L12.76 27.97C12.837 27.989 12.917 28 13 28C13.205 28 13.396 27.938 13.554 27.832L19.186 24.077L26.757 25.97C27.056 26.045 27.372 25.978 27.615 25.788C27.858 25.598 28 25.308 28 25V7C28 6.541 27.688 6.141 27.242 6.03V6.03ZM6 8.281L12 9.781V25.719L6 24.219V8.281ZM18 22.465L14 25.132V9.536L18 6.869V22.465V22.465ZM26 23.719L20 22.219V6.281L26 7.781V23.719Z" />
	</svg>
);

export default Map;
